module.exports = __webpack_public_path__ + "img/black.8d4d3e47.svg";